//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').service('DatatableService', [
    '$rootScope',
    'StringUtils',
    function(
            $rootScope,
            StringUtils,
        ) {
            //
            // Helper methods
            //

      this.generatePages = function(pagination) {
        const MAX_PAGES_DISPLAYED = 5;
        const numItems = pagination.total;
        const itemsPerPage = pagination.itemsPerPage;
        const currentPage = pagination.currentPage;
        const lastPage = Math.ceil(numItems / itemsPerPage);
        const pages = [];
        let i;
        let start;

        if (currentPage + Math.ceil(MAX_PAGES_DISPLAYED / 2) > lastPage) {
                    // We're near the end of the list
          start = Math.max(0, lastPage - MAX_PAGES_DISPLAYED);
        } else {
                    // Show current page in middle of list, unless we are in the first few pages of the list
          start = Math.max(0, currentPage - Math.ceil(MAX_PAGES_DISPLAYED / 2));
        }

        for (i = start; i < Math.min(lastPage, start + MAX_PAGES_DISPLAYED); i++) {
          pages.push(i + 1);
        }

        return pages;
      };

      this.isDeferredObject = function(deferred) {
        return !!deferred && typeof deferred.then === 'function' && typeof deferred.catch === 'function' && typeof deferred.finally === 'function';
      };

      this.sortAndPaginate = function(items, pagination, sorting) {
        let sortedItems;
        const start = (pagination.currentPage - 1) * pagination.itemsPerPage;
        const end = (pagination.currentPage) * pagination.itemsPerPage;
        const sortKey = sorting.currentSortKey;
        const direction = sorting.direction;

                // We support sorting on nested properties (e.g foo.bar), but Underscore's sortBy function does not.  To get
                // this works we need to parse the sort key and use our own sort function to sort nested properties properly.

        if (!sortKey && direction === 'asc') {
          return _(items).slice(start, end);
        } else if (!sortKey) {
          return _(items).reverse().slice(start, end);
        }

        const sortKeyArray = sortKey.split('.');
        const sortFunction = function(item) {
          let i;
          for (i = 0; i < sortKeyArray.length; i++) {
            item = item[sortKeyArray[i]];
          }

          return item;
        };

        if (sortKey && direction === 'asc') {
          sortedItems = _(items).sortBy(sortFunction);
        } else if (sortKey) {
          sortedItems = _(items).sortBy(sortFunction).reverse();
        } else {
          sortedItems = items;
        }

        return sortedItems.slice(start, end);
      };

            //
            // Cross-component coordination
            //

      this.changeView = function(tableName, view) {
        const eventName = StringUtils.formatString('datatable:%s:change-view', tableName);

        if (view !== 'grid' && view !== 'table' && view !== 'empty' && view !== 'list') {
          throw new Error(`Unsupported view: ${view}`);
        }

        return $rootScope.$broadcast(eventName, view);
      };

      this.notifyPaginationUpdate = function(tableName, pagination) {
        const eventName = StringUtils.formatString('datatable:%s:update-pagination', tableName);

        return $rootScope.$broadcast(eventName, pagination);
      };

      this.reloadDatatables = function() {
        return $rootScope.$broadcast('datatable:*:reloadDatatables');
      };

      this.reloadDatatable = function(tableName) {
        return $rootScope.$broadcast('datatable:reloadDatatable', tableName);
      };

            // Resets the datatable multicols array needed for multiple data column headers.
      this.resetMultiCols = function(tableName) {
        const eventName = StringUtils.formatString('datatable:%s:reset-multi-cols', tableName);

        return $rootScope.$broadcast(eventName);
      };

            // Sets a new sort key for the specified table. If changeDirection is false, the table won't change the
            // sort direction if the active sort key for the table is already the specified sort key.
      this.newSort = function(tableName, sortKey, changeDirection) {
        const eventName = StringUtils.formatString('datatable:%s:new-sort', tableName);

        return $rootScope.$broadcast(eventName, sortKey, changeDirection);
      };
    },
  ]);
})();
